import { FilterChangedEvent, IFloatingFilter } from 'ag-grid-community';
import { IrisFloatingFilterParams } from '@iris/common/modules/grid/ag-grid/models/floating-filter-params';

export abstract class IrisAgGridFloatingFilterBaseComponent<T extends IrisFloatingFilterParams = IrisFloatingFilterParams> implements IFloatingFilter {
  params: T;

  agInit(params: T) {
    this.params = params;

    this.params.templateContext = {
      ...this.params.templateContext,
      valueChanged: (newValue) => this.valueChanged(newValue),
    };
  }

  valueChanged(newValue: any) {
    this.params?.parentFilterInstance(instance => {
      (<any> instance).onFloatingFilterChanged?.(newValue);
    });
  }

  onParentModelChanged(parentModel: any, filterChangedEvent?: FilterChangedEvent): void {
  }
}
